import { render, staticRenderFns } from "./SlideSendMail.vue?vue&type=template&id=5f7b92a0"
import script from "./SlideSendMail.vue?vue&type=script&lang=js"
export * from "./SlideSendMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports